import { Box, Paper, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const FormContainer = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
  min-width: 320px;
`;

const SectionCard = styled(Paper)`
  padding: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: none;
`;

const SectionTitle = styled('h3')`
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  font-weight: 600;
`;

const Row = styled(Box)`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 10px;
`;

const Col4 = styled(Box)`
  grid-column: span 4;
`;

const Col3 = styled(Box)`
  grid-column: span 3;
`;

const Col6 = styled(Box)`
  grid-column: span 6;
`;

const Col8 = styled(Box)`
  grid-column: span 8;
`;

const Col12 = styled(Box)`
  grid-column: span 12;
`;

const Campo = styled(TextField)`
  width: 100%;
`;

const TotalContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  font-size: 0.9rem;
  font-weight: 600;
`;

export { FormContainer, SectionCard, SectionTitle, Row, Col3, Col4, Col6, Col8, Col12, Campo, TotalContainer };
